import React from 'react';
import { StyledH2 } from './index.styled';
import { withTranslationText } from '../../hoc/withTranslationText';

export const H2 = withTranslationText(({ renderText, children, ...props }) => (
    <StyledH2 {...props}>{renderText ? renderText : children}</StyledH2>
));
